import { Component, OnInit,ViewChild,ElementRef, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions ,} from 'ngx-extended-pdf-viewer';

//import { HttpClient } from '@angular/common/http';
//import { tap } from 'rxjs/operators';
//import { Subject } from 'rxjs';




@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {

  @Input() pdfurl:any
  

  
  constructor(public modalController: ModalController,public ngxpdf: NgxExtendedPdfViewerModule,
    ) {
    //pdfDefaultOptions.doubleTapZoomFactor = "130%";
    pdfDefaultOptions.useOnlyCssZoom=true;
   }

  public enablePinchOnMobile = true;
  public isMobile = 'ontouchstart' in document.documentElement;
  public minZoom = 0.33;
  public maxZoom = 4;
  public zoomLevels = ['auto', 'page-actual', 'page-fit', 'page-width', 0.2, 0.25, 0.33, 0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3, 3.5, 4,5,6,7,8];
  private _zoomSetting: number | string | undefined = 'page-width';
  public currentZoomFactor: number;
  // getter and setter make the demo nicer -
  // you probably don't need them in your code
  public get zoomSetting() {
    return String(this._zoomSetting);
  }
  public set zoomSetting(zoom: string) {
    if (isNaN(Number(zoom))) {
      this._zoomSetting = zoom;
    } else {
      this._zoomSetting = zoom + '%';
    }
  }
  public updateZoomFactor(zoom: number): void {
    this.currentZoomFactor = zoom;
  }



    // public enablePinchOnMobile = true;
    // public isMobile = 'ontouchstart' in document.documentElement;
    // public minZoom = 0.33;
    // public maxZoom = 3;
    // public zoomLevels = ['auto', 'page-actual', 'page-fit', 'page-width', 0.2, 0.25, 0.33, 0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3, 3.5, 4];
    // private _zoomSetting: number | string | undefined = 'page-width';
    // private currentZoomFactor: number;
    // // getter and setter make the demo nicer -
    // // you probably don't need them in your code
    // public get zoomSetting() {
    //   return String(this._zoomSetting);
    // }
    // public set zoomSetting(zoom: string) {
    //   if (isNaN(Number(zoom))) {
    //     this._zoomSetting = zoom;
    //   } else {
    //     this._zoomSetting = zoom + '%';
    //   }
    // }
    // public updateZoomFactor(zoom: number): void {
    //   this.currentZoomFactor = zoom;
    // }

    // public zoom = '150%';




  ngOnInit() {
    // this.httpClient.get(
    //   this.pdfurl,
    //   { responseType: 'text' as 'json' })
    // .pipe(
    //   tap((base64) => {
    //     console.log(base64);
    //     this.base64 = base64; }),
    // ).subscribe();

    // this.getBase64ImageFromUrl(this.pdfurl)
    // .then(result => {
    //   //console.log(result);
    //   this.base642=result
    //   let temp=this.base642.replace(/\s/g, "").split(",", 2);
    //   console.log(temp);
    //   this.base64=temp[1]
    // })
    // .catch(err => console.error(err));
    
  }

  // async getBase64ImageFromUrl(imageUrl) {
  //   var res = await fetch(imageUrl);
  //   var blob = await res.blob();
  
  //   return new Promise((resolve, reject) => {
  //     var reader  = new FileReader();
  //     reader.addEventListener("load", function () {
  //         resolve(reader.result);
  //     }, false);
  
  //     reader.onerror = () => {
  //       return reject(this);
  //     };
  //     reader.readAsDataURL(blob);
  //   })
  // }

  ngAfterViewInit(){
    
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }


}
